import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/assets/css/main.css';

Vue.config.productionTip = false;

import Convert from './plugins/convert';
import VeeValidate from './plugins/veeValidate';
import Vue2GoogleMaps from './plugins/Vue2GoogleMaps';
import VueApexCharts from './plugins/VueApexCharts';
import VCurrencyField from './plugins/VCurrencyField';

import MarqueeText from 'vue-marquee-text-component';
Vue.component('marquee-text', MarqueeText);

import Notifications from 'vue-notification';
Vue.use(Notifications);

import axios from 'axios';

axios.defaults.timeout = 1000 * 30;
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function(err) {
    return new Promise(function() {
      if (
        err.response &&
        err.response.status === 401 &&
        err.response.data.error_code === 'token_expired' &&
        err.config &&
        !err.config.__isRetryRequest
      ) {
        store.dispatch('clearSessions');
        router.push('/login');
      }
      throw err;
    });
  }
);

new Vue({
  router,
  store,
  vuetify,
  Convert,
  VeeValidate,
  Vue2GoogleMaps,
  VueApexCharts,
  VCurrencyField,
  render: (h) => h(App)
}).$mount('#app');
